module.exports = __webpack_public_path__ + "static/media/info-icon-green.112995b6.svg";